import 'babel-polyfill'; // babel-polyfill must be the first import!
import './Globals.scss';

import EventBus from 'appRoot/scripts/EventBus';

import Vue from 'vue';
import App from 'appRoot/vues/App.vue';
import CreateStore from 'appRoot/store/store';
import CreateRouter from 'appRoot/router/index';


import vsvg from 'appRoot/vues/common/controls/VSvg.vue';
Vue.component('vsvg', vsvg);

import SvgButton from 'appRoot/vues/common/controls/SvgButton.vue';
Vue.component('SvgButton', SvgButton);

import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import VueToastr from '@deveodk/vue-toastr';
Vue.use(VueToastr);

import VueGoodTablePlugin from 'vue-good-table'; // this is an enormous dependency, and could be removed in order to reduce bundle size
import 'vue-good-table/dist/vue-good-table.css'; // ^^
Vue.use(VueGoodTablePlugin);

import ScaleLoader from 'appRoot/vues/common/ScaleLoader.vue';
Vue.component('ScaleLoader', ScaleLoader);

import VueVirtualScroller from 'vue-virtual-scroller';
Vue.use(VueVirtualScroller);

import VueDOMPurifyHTML from 'vue-dompurify-html';

Vue.use(VueDOMPurifyHTML, {
	namedConfigurations: {
		plaintext: {
			USE_PROFILES: { html: false },
		},
	},
});


// Any recursively nested components must be globally registered here
//Vue.component('Example', require('Example.vue').default);

let store = window.store = CreateStore();

if (startupSession)
{
	store.commit("SessionAuthenticated", { sid: startupSession.sid, userData: startupSession.userData });
	startupSession = undefined;
}

let router = window.router = CreateRouter(store, appContext.appPath);
let myApp = window.myApp = new Vue({
	store,
	router,
	...App
});

import ToasterHelper from 'appRoot/scripts/ToasterHelper';
window.toaster = new ToasterHelper(myApp.$toastr);

let uidCounter = 0;
window.GetUid = function ()
{
	return uidCounter++;
};

window.addEventListener('unhandledrejection', function (e)
{
	let msg = e.reason ? e.reason.toString() : JSON.stringify(e);
	try
	{
		toaster.error("Unhandled Promise Rejection", msg);
	}
	catch (ex)
	{
		console.error(ex);
		alert("Unhandled Promise Rejection: " + msg);
	}
});
Vue.config.errorHandler = function (err, vm, info)
{
	// `info` is a Vue-specific error info, e.g. which lifecycle hook
	// the error was found in. 
	console.log("Vue errorHandler:");
	console.error(err, info, vm);
	if (typeof err.tdsErrorHandled === "undefined" || !err.tdsErrorHandled)
	{
		err.tdsErrorHandled = true;
		var errMsg = err;
		try
		{
			errMsg += '\r\n\r\nVue-specific error info: "' + info + '"';
		}
		catch (ex2)
		{
			errMsg += '\r\n\r\nVue-specific error info: [unable to read info object]';
		}
		try
		{
			errMsg += '\r\n\r\nComponent HTML: ' + vm.$el.innerHTML;
		}
		catch (ex2)
		{
			errMsg += '\r\n\r\nComponent HTML: [unable to read component html]';
		}
		try
		{
			toaster.error("Vue Error", errMsg);
		}
		catch (ex)
		{
			console.error(ex);
			alert("Vue Error: " + errMsg);
		}
	}
};

router.onReady(() =>
{
	const matchedComponents = router.getMatchedComponents();

	if (matchedComponents.length < 1)
		window.location.replace(appContext.appPath + "404.html");

	myApp.$mount('#app');
});

